import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import HeaderContainer from "@/components/HeaderContainer/HeaderContainer.vue";
import LoginPage from "@/components/LoginPage/LoginPage.vue";
import { ref, onMounted, nextTick, watch } from "vue";
import bus from "./lib/bus";
import { shareStatus, getMaintainStatus, getOtherConfig } from "@/api/api";
import router from "./router";
import { getUserInfo } from "@qcplay/platform-ui";
import { initSDK, wechatShareAction, processPayment, getI18nLangConfigText } from "@/utils/utils";
import { platformStore } from "@/store/index";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";
export default {
  name: "App",
  components: {
    HeaderContainer,
    LoginPage
  },
  setup() {
    const {
      t
    } = useI18n();
    const store = platformStore();
    const route = useRouter();
    const currentRoute = useRoute();
    // 登录弹窗
    const show = ref(false);
    const loginPage = ref(null);
    const showLogins = () => {
      show.value = true;
      nextTick(() => {
        if (loginPage.value && typeof loginPage.value.showSDKLogin === "function") {
          loginPage.value.showSDKLogin();
        } else {
          console.warn("LoginPage 组件或 showSDKLogin 方法未准备好");
        }
      });
    };
    const showService = ref(false); //客服弹窗状态
    const kfUrl = ref(""); //客服链接
    const myIframe = ref(null);
    // 联系客服
    bus.$on("showKf", () => {
      kfUrl.value = store.kfUrl;
      //判断是否为移动端
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        showService.value = true;
      } else {
        window.open(kfUrl.value, "_blank");
      }
    });
    const closeLoginContainer = () => {
      show.value = false;
    };
    const listenClose = () => {
      bus.$emit("scrollGoToTop");
    };
    // 登录成功
    const token = ref("");
    bus.$on("sendToken", e => {
      token.value = e;
      show.value = false;
    });
    //获取维护状态
    bus.$on("maintainStatus", () => {
      // 获取当前路由
      const routeSec = router.currentRoute.value;
      if (routeSec.path == "/" || routeSec.path == "/home") return;
      getMaintainType();
    });
    // 调取登录弹窗
    bus.$on("click", async () => {
      showLogins();
    });
    // 监听是否进充值页
    const isPay = ref(false);
    bus.$on("showPayHeader", () => {
      isPay.value = true;
    });
    bus.$on("closePayHeader", () => {
      isPay.value = false;
    });
    const desktopPopup = ref(false); //pwa引导页弹窗
    const isWechat = ref(false);
    const isAndroid = ref(false);
    bus.$on("deskTop", e => {
      // 判断当前是否为微信环境
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        isWechat.value = true;
      }
      // 判断是否为安卓设备
      if (ua.indexOf("android") > -1) {
        isAndroid.value = true;
      }
      desktopPopup.value = true;
      showChecked.value = e || false;
    });
    const checked = ref(false);
    const showChecked = ref(false);
    // 关闭PWA弹窗
    const closePopup = () => {
      if (store.popupType == 2) return desktopPopup.value = false;
      if (checked.value) {
        // 请求服务端改变弹窗状态
        shareStatus({
          game_id: store.gameId,
          official_setting_id: store.officialSettingId
        });
        desktopPopup.value = false;
      }
      desktopPopup.value = false;
    };
    // 监听注销弹窗
    bus.$on("showLoginoutPoPup", () => {
      showLoginout.value = true;
    });
    const showLoginout = ref(false); //注销弹窗
    // 确定注销
    const logoutBtn = () => {
      bus.$emit("clear");
      store.setAccessToken("");
      store.setUserId("");
      store.setLoginWay("");
      showLoginout.value = false;
    };
    const announcementText = ref(""); //维护文案
    // 监听开启维护弹窗
    bus.$on("showMaintenance", e => {
      if (e) announcementText.value = getI18nLangConfigText({
        ...e,
        detail: 'detail'
      }, 'detail');
      announcementPopup.value = true;
    });
    const announcementPopup = ref(false); //维护公告弹窗
    // 关闭维护提示弹窗
    const closeAnnouncement = () => {
      announcementPopup.value = false;
      if (!store.gameId) {
        return router.push({
          path: "/home"
        });
      }
    };
    const maintainFrom = ref(""); //判断当前页面的上一级页面
    const MAX_ATTEMPTS = 3; // 最大尝试次数

    // 获取维护状态
    const getMaintainType = (attempt = 1) => {
      if (!store.gameId) {
        if (attempt < MAX_ATTEMPTS) {
          return setTimeout(() => {
            getMaintainType(attempt + 1);
          }, 1000);
        } else {
          if (maintainFrom.value.path == "/" || maintainFrom.value.path == "/home") return;
          // 达到最大尝试次数后的逻辑
          bus.$emit("showMaintenance");
          return;
        }
      }

      // gameId 存在时执行的逻辑
      getMaintainStatus({
        game_id: store.officialSettingId || ""
      }).then(res => {
        if (res.code == 200) {
          if (res.metadata.status == 1) {
            bus.$emit("showMaintenance", res.metadata);
            store.setMaintenanceStatus("open");
            return;
          }
          store.setMaintenanceStatus("close");
        }
      });
    };
    const initSdhType = ref(false); //sdk初始化状态
    const routeRandom = ref("");
    const getRouteRandom = () => {
      const randomParam = currentRoute.params?.random;
      if (Array.isArray(randomParam)) {
        return randomParam[0] || "";
      }
      return randomParam || "";
    };
    const shouldSkipInitGuard = () => {
      // 牛丸数据迁移专用
      return currentRoute.matched.some(record => record.meta?.skipInitGuard === true);
    };
    watch(() => currentRoute.params?.random, () => {
      routeRandom.value = getRouteRandom();
    }, {
      immediate: true
    });
    const isPwa = () => {
      // 检查 display-mode: standalone
      if (window.matchMedia("(display-mode: standalone)").matches) {
        return 1;
      }

      // 检查 iOS Safari 的 standalone 模式
      if ("standalone" in window.navigator && window.navigator.standalone) {
        return 1;
      }

      // 检查 display-mode: fullscreen
      if (window.matchMedia("(display-mode: fullscreen)").matches) {
        return 1;
      }

      // 检查 display-mode: minimal-ui
      if (window.matchMedia("(display-mode: minimal-ui)").matches) {
        return 1;
      }
      return 2;
    };
    onMounted(async () => {
      isMobileType.value = isMobile();
      store.setIsPwa(isPwa());
      await route.isReady();
      routeRandom.value = getRouteRandom();
      const urlParams = new URLSearchParams(window.location.search);
      const gameId = urlParams.get("gameId");
      const officialSettingId = urlParams.get("officialSettingId");
      if (gameId) {
        store.setGameId(gameId);
      }
      if (officialSettingId) {
        store.setOfficialSettingId(officialSettingId);
      }
      document.title = t("qc_sdk_official_recharge");
      changeFavicon(store.webIcon);
      if (store.nowType == "zhcn") {
        wechatShareAction();
      }
      if (shouldSkipInitGuard()) {
        initSdhType.value = true;
        store.setGameId(39);
      }
      if (!store.gameId && !store.officialSettingId) {
        initSdhType.value = true;
        if (!shouldSkipInitGuard()) {
          route.push({
            name: "homepage"
          });
        }
        return;
      }
      if (!store.gameId && store.officialSettingId) {
        await getOtherConfig({
          official_setting_id: store.officialSettingId
        }).then(res => {
          store.setGameId(res.metadata.game_id);
        });
      }
      await initSDK().then(async () => {
        if (route.currentRoute.value.query.auth_code) {
          await processPayment(route, route.currentRoute.value);
        }
        initSdhType.value = true;
        store.setSdkInitialized(true);
      });
      if (!store.userId && store.access_token) {
        await getUserInfo(store.access_token).then(res => {
          store.setUserId(res.metadata.user_id);
        });
      }
    });
    // 修改favicon
    const changeFavicon = url => {
      const timestamp = Date.now();
      const fullUrl = `${url}?v=${timestamp}`;

      // 查找现有的 favicon
      const existingLink = document.querySelector("link[rel='icon']");
      if (existingLink) {
        // 存在则直接修改 href
        existingLink.href = fullUrl;
      } else {
        // 不存在则创建新的
        const newFavicon = document.createElement('link');
        newFavicon.rel = 'icon';
        newFavicon.href = fullUrl;
        document.head.appendChild(newFavicon);
      }
    };
    // 判断当前页面是否为移动端
    const isMobileType = ref(false);
    const isMobile = () => {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };
    bus.$on("getStatus", e => {
      maintainFrom.value = e || "";
      if (!store.access_token) return;
      getMaintainType();
    });
    bus.$on("clearStatus", () => {
      maintainFrom.value = "";
      store.setOfficialSettingId("");
    });
    return {
      isAndroid,
      kfUrl,
      getMaintainType,
      announcementText,
      closeAnnouncement,
      announcementPopup,
      myIframe,
      showService,
      logoutBtn,
      showLoginout,
      closePopup,
      showChecked,
      checked,
      desktopPopup,
      listenClose,
      isPay,
      token,
      show,
      showLogins,
      closeLoginContainer,
      isWechat,
      isMobileType,
      loginPage,
      initSdhType
    };
  }
};